/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
import { depthwiseConv2d } from '../../ops/depthwise_conv2d';
import { getGlobalTensorClass } from '../../tensor';
getGlobalTensorClass().prototype.depthwiseConv2d =
    function (filter, strides, pad, dataFormat, dilations, dimRoundingMode) {
        this.throwIfDisposed();
        return depthwiseConv2d(this, filter, strides, pad, dataFormat, dilations, dimRoundingMode);
    };
//# sourceMappingURL=depthwise_conv2d.js.map